
import Coms from '@/communications'
import bus from '@/plugins/bus'

export default {
  async getReport ({ commit }, reportId) {
    try {
      const report = await Coms.savedReport.getSavedReport(reportId)
      commit('setSavedReport', report)
      return report
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, { color: 'error', dark: true })
      throw err
    }
  },
  async getSharedReport ({ commit }, reportId) {
    try {
      const report = await Coms.sharedReports.getReport(reportId)
      commit('setSavedReport', report)
      return report
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, { color: 'error', dark: true })
      throw err
    }
  },
  async getFeedbackReport ({ commit }, reportId) {
    try {
      const report = await Coms.feedback.getFeedbackReport(reportId)
      if (report) {
        commit('setSavedReport', report)
      }
      return report
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, { color: 'error', dark: true })
      throw err
    }
  },
  async getSharedReportFromLink ({ commit }, linkId) {
    try {
      const report = await Coms.sharedReports.getSharedLinkReport(linkId)
      if (report) {
        commit('setSavedReport', report)
      }
      return report
    } catch (err) {
      console.error(err)
      bus.emit('notification', err, { color: 'error', dark: true })
      throw err
    }
  }
}
